
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/content-migrations/jst/subviews/ExternalToolLaunch';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<label class=\"control-label\" for=\"externalToolLaunch\"><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.external_tool_launch")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.external_tool_launch.course", "Course", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.external_tool_launch.course", "Course", options)))
    + "</strong></label>\n<div class=\"controls\">\n  <button id=\"externalToolLaunch\" class=\"btn\" type=\"button\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.external_tool_launch")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.external_tool_launch.find_a_course", "Find a Course", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.external_tool_launch.find_a_course", "Find a Course", options)))
    + "</button>\n  <span class='file_name'></span>\n</div>";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  